import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loading.svg'


const _withScopeId = n => (_pushScopeId("data-v-6c1b739d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-height":"100vh"} }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sauvegarder ")
const _hoisted_4 = {
  key: 1,
  class: "spinner"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "UNUCR"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { request } from "@/domains/api/api";
import { computed, ref } from "@vue/reactivity";
import * as marked from "marked";
import * as DOMpurify from "dompurify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const submitting = ref(false);
const markdown = ref("");
const renderedHtml = computed(() =>
    DOMpurify.sanitize(marked.parse(markdown.value))
);

request<string>("news", "get").then((data) => {
    if (!data) return;
    markdown.value = data;
});

function save() {
    if (submitting.value) return;
    submitting.value = true;
    request<string>("news", "put", null, { markdown: markdown.value }).finally(
        () => (submitting.value = false)
    );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((markdown).value = $event))
    }, null, 512), [
      [_vModelText, markdown.value]
    ]),
    (_unref(renderedHtml))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: _unref(renderedHtml),
          class: "markdown-body"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: save,
      class: "btn btn-primary"
    }, [
      (!submitting.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
    ])
  ]))
}
}

})